import React from "react";
import Loader from "../../Loader";
import PageContent from "./PageContent";

const LoginSuccess = () => {
	return (
		<>
			<Loader />
			<PageContent />
		</>
	);
};
export default LoginSuccess;
